// extracted by mini-css-extract-plugin
export default {"timer":"MessageTimer_timer__Sjxx6"};